import { gsap, ScrollTrigger } from '../global/gsap';

const initColorCards = (cards) => {
    cards.forEach((card) => {
        card.classList.remove('active');
        const cardTl = gsap.timeline({
            scrollTrigger: {
                trigger: card,
                start: 'top 80%',
                onEnter: () => {
                    card.classList.add('active');
                },
            },
        });
    });
};

export default initColorCards;
